import React, {createContext, useContext, useEffect, useState} from "react"
// import { locationsArray } from "../utils/data"
import {getAllStores} from "../services/getAllStores";


// Create the context
const AppContext = createContext()

// Create a provider component
export const AppProvider = ({ children }) => {
    
    const [locations, setLocations] = useState()
    const [currentPage, setCurrentPage] = useState("map")
    const [nearestStores, setNearestStores] = useState([])
    const [visibleStores, setVisibleStores] = useState(3)
    const [searchTerm, setSearchTerm] = useState('')
    const [form, setForm] = useState({
        location: null,
        date: null,
        time: null,
        testId: null,
        staffId: "any",
        staffName: "Any",
        appointmentId: null,
        clientId: null,
        bookingForm: {
            salutation: "Mr",
            firstName: "",
            lastName: "",
            personMobilePhone: "",
            personEmail: "",
            Diabetes__pc: "No",
            First_Appointment__c: false,
            Dont_Confirm__c: false,
            Communication_Preferences__c: false,
            Marketing_Opt_In__c: false
        }
    })

    // Function to update locations
    const updateLocations = (newLocations) => {
      setLocations(newLocations)
    }
    useEffect(() => {
        const fetchLocations = async () => {
            const stores = await getAllStores();
            setLocations(stores); // Update locations with API data
        };
        fetchLocations();
    }, []);
    return (
        <AppContext.Provider value={{ 
            locations, updateLocations, 
            form, setForm, 
            nearestStores, setNearestStores, 
            visibleStores, setVisibleStores,
            currentPage, setCurrentPage, 
            searchTerm, setSearchTerm
        }}>
            {children}
        </AppContext.Provider>
    )
}
  
// Custom hook to use the AppContext
export const useApp = () => {
    return useContext(AppContext)
}